
export const solutions = [
  {
    slug: 'cctv-system', 
    title: 'CCTV System', 
    category: 'Security Systems', 
    intro: "Partnering with Honeywell, we deliver next‑generation CCTV  solutions built on intelligent analytics.",
    body: [
      "AI Cameras, NVRs, DVRs, decoders, IVS, and cloud/video management platforms enhance safety for intelligent cities, transportation, energy, manufacturing, campuses, by enabling real‑time monitoring and rapid incident response.",
      "Camera types include PTZ, Dome, Bullet, Thermal, and Anti-Bullet models, supporting centralized remote monitoring and comprehensive day/night event recording."
    ],
    features: [
      "High‑resolution IP cameras with AI analytics and night vision",
      "24/7 surveillance with centralized remote monitoring",
      "Motion/event detection, alerts, and full recording",
      "RAID backup for secure, redundant storage",
      "NVRs, DVRs, and decoders for robust multi-channel recording",
      
    ],
    image: require('../assets/solutions/cctv-system.png'),
    images: [
      require('../assets/solutions/cctv-system_2.png'),
      require('../assets/solutions/cctv-system_1.png'),
      
    ],
  },
  {
    slug: 'access-control', 
    title: 'Access Control', 
    category: 'Security Systems', 
    intro: "We partner with Safe Eye to provide advanced access control that regulates the entry and exit of people or vehicles and enforces time‑based permissions for secure, efficient operations in facilities, banks, and factories.",
    body: [
      "Users can open doors using biometrics (fingerprint/face), security cards, or PIN codes—removing the need for traditional keys.",
      "We provide 2-door panels and 4-door cloud-based controllers, as well as RFID readers for outdoor use and home access control solutions.",
      "Modern software comes with full monitoring, data collection, visitor management, policy control."
    ],
    features: [
      "Biometric, card, and PIN authentication",
      "Role-based and time-scheduled permissions",
      "Centralized management",
      "2-door panels and 4-door cloud controllers",
      "RFID readers for outdoor access",
      "Modern software with full monitoring and data collection"
    ],
    image: require('../assets/solutions/access-control.png'),
    images: [
      require('../assets/solutions/access-control_1.png'),
      require('../assets/solutions/access-control.png'),
      
      
    ],
    productsLink: 'https://safeeye.uk/product-category/access-control/'
  },

  { 
    slug: 'fire-alarm', 
    title: 'Fire Alarm', 
    category: 'Fire Systems', 
    intro: 'We partner with Edwards and Honeywell to provide addressable fire alarm systems that detect fires at the earliest stage and provide immediate alerts to protect lives and property.',
    body: [
      'Smart control panels pinpoint the exact alarm location and support on‑site and remote programming to meet facility needs.',
      'Systems comply with BS, EN, and NFPA codes, integrate with traditional/addressable/wireless devices, and support centralized battery backup for emergency lighting and exit signs.'
    ],
    features: [
      'Addressable and smart control panels',
      'On‑site and remote configuration',
      'Centralized battery backup for life‑safety circuits',
      'Compliance with BS/EN/NFPA standards'
    ],
    image: require('../assets/solutions/fire-alarm.png'),
    images: [
      require('../assets/solutions/fire-alarm.png'),
      require('../assets/solutions/fire-alarm_1.jpg'),
    
    ]
  },

  { 
    slug: 'power-backup-solution', 
    title: 'Power Backup Solution', 
    category: 'Power Solutions', 
    intro: "We partner with Voltvision to deliver advanced UPS and power backup systems, ensuring continuous, reliable power for critical operations.",
    body: [
      "Voltvision’s UPS portfolio spans YPA Series (600–3000VA), VR Series (1–3kVA, 6–10kVA, and 10–20kVA), HVV33 Series (10–80kVA), and HVV Series (50–200kVA).",
      "Solutions are engineered for high efficiency, scalability, and reliability—reducing downtime and ensuring seamless transitions during power disruptions.",
      "A complete backup solution combines UPS for instant power and conditioning with battery banks for extended runtime and safe shutdown.",
      "Applications include offices, retail, industrial sites, and data centers where continuity and equipment protection are essential."
    ],
    features: [
      "UPS capacities from 600VA up to 200kVA",
      "Line-interactive and online double-conversion topologies",
      "Parallel redundancy (N+X) for scalability and reliability",
      "Hot-swappable batteries and smart charging technology",
      "Surge protection, AVR, and clean shutdown with generator integration",
      "Advanced monitoring via LCD panels, SNMP, RS232/USB, or software"
    ],
    image: require('../assets/solutions/power-backup-solution.png'),
    images: [
      require('../assets/solutions/power-backup-solution_1.png'),
      require('../assets/solutions/power-backup-solution_2.png'),
      require('../assets/solutions/power-backup-solution_3.png'),
      
      
    ],
    productsLink: 'https://voltvision.uk/our-products/ups/'
  },
  {
    slug: 'avr',
    title: 'AVR',
    category: 'Power Solutions',
    intro: 'We partner with Voltvision to provide voltage stabilizers that regulate and stabilize voltage, protecting equipment and maintaining power quality.',
    body: [
      'AVR units compensate for fluctuations, reduce line loss, and improve stability for sensitive loads.',
      'They support grid fault recovery and integration of distributed energy while safeguarding downstream equipment.'
    ],
    features: [
      'High‑accuracy regulation with fast response',
      'Over/under‑voltage and surge protection',
      'Harmonic and transient suppression'
    ],
    image: require('../assets/solutions/avr.png'),
    productsLink: 'https://voltvision.uk/our-products/avr/'
  },
  {
    slug: 'solar-system', 
    title: 'Solar System', 
    category: 'Power Solutions', 
    intro: "We partner with Voltvision to deliver solar systems that convert sunlight into electricity, reducing bills and providing sustainable energy for homes and businesses.",
    body: [
      "Our solutions include on-grid,off-grid, and hybrid Solutions",
      "Voltvision provides inverters (3.6 kW and 6 kW), high-efficiency solar panels (610W and 730W), and lithium batteries available in 10kWh (vertical and wall-mount) and 14kWh (vertical) models.",
      "All systems are engineered for high efficiency, durability, and safe integration with existing electrical infrastructure."
    ],
    features: [
      "High-efficiency PV modules: 610W and 730W",
      "Inverters: 3.6 kW and 6 kW models",
      "Lithium batteries: 10kWh (vertical & wall-mount) and 14kWh (vertical)",
      "On-grid,Off-grid, and Hybrid options with battery storage",
      "Safe installation with compliant mounting and protection devices"
    ],
    image: require('../assets/solutions/solar-system.png'),
    images: [
      require('../assets/solutions/solar-system_1.webp'),
      require('../assets/solutions/solar-system_2.webp'),
      require('../assets/solutions/solar-system_3.webp'),

    ],
    productsLink: 'https://voltvision.uk/our-products/inverters/'
  },
  

  {
    slug: 'firefighting-system', 
    title: 'Firefighting System', 
    category: 'Fire Systems', 
    intro: 'Automatic and non‑automatic firefighting systems extinguish fires in facilities and buildings, with types selected according to the risks and environment.',
    body: [
      'Such systems are essential when constructing new facilities—especially factories and companies—to reduce losses and control fires when they occur.',
      'Solutions include sprinklers, hydrants, extinguishers, and special‑hazard systems tailored to each site.'
    ],
    features: [
      'Automatic and manual suppression options',
      'Risk‑based system selection and design',
      'Rapid control to minimize losses'
    ],
    image: require('../assets/solutions/firefighting-system.png'),
   
  },
  {
    slug: 'fire-suppression-system', 
    title: 'Fire Suppression System', 
    category: 'Fire Systems', 
    intro: 'Power generation and distribution sites require robust suppression systems to protect turbines, generators, transformers, and cable tunnels that must run continuously.',
    body: [
      'Damage to one sensitive asset can cause collateral damage to others. To prevent danger, we deploy reliable extinguishing systems around each electrical power transformer and other critical equipment.',
      'Solutions use water spray, foam, or clean agents engineered for electrical hazards.'
    ],
    features: [
      'Focused protection for transformers and electrical assets',
      'High reliability for mission‑critical facilities',
      'Agent selection suitable for energized equipment'
    ],
    image: require('../assets/solutions/fire-suppression-system.png')
  },
  {
    slug: 'emergency-light-system', 
    title: 'Emergency Light System', 
    category: 'Fire Systems', 
    intro: 'Battery‑powered emergency lighting turns on automatically during power outages to provide safe visibility and guidance throughout buildings.',
    body: [
      'These systems are essential for compliance in commercial buildings, hospitals, schools, malls, industrial facilities, and public venues—reducing risk and supporting evacuations.',
      'Solutions feature long battery life and easy integration and include exit signs, wall‑mounted lights, and ceiling units.'
    ],
    features: [
      'Automatic activation during outages',
      'Long‑life battery backup',
      'Exit signs, wall and ceiling fixtures'
    ],
    image: require('../assets/solutions/emergency-light-system.png')
  },
  {
    slug: 'fire-rated-doors', 
    title: 'Fire-Rated Doors', 
    category: 'Fire Systems', 
    intro: 'Fire‑rated doors',
    body: [
      'They enable safe evacuation routes , giving people more time to escape and responders time to act.',
      'Commonly installed in commercial buildings, hospitals, schools, industrial facilities, and residential complexes to meet stringent regulations.'
    ],
    features: [
      'Certified fire/smoke resistance (up to 3 hours)',
      'Egress support',
      'Compliance with international standards'
    ],
    image: require('../assets/solutions/fire-rated-doors.png')
  },

  {
    slug: 'voip-phone-system', 
    title: 'VOIP Phone System', 
    category: 'Communication Systems', 
    intro: "We partner with Mitel and Safe Eye to provide flexible and scalable VoIP phone systems.",
    body: [
      "VoIP integrates with IP phones from Safe Eye supporting all use cases including hotel rooms, offices, and more.",
      "We provide PBX systems from Mitel and Safe Eye in various sizes: 20, 50, 100, 200, 500, 1000, and 10,000 lines, expandable via licenses up to 12,000 lines and supporting up to 600 concurrent calls with 1TB storage space.",
      "Features include unlimited intercom and IVR, with full integration across all departments and locations for smooth communication and improved productivity."
    ],
    features: [
      
      "Unified communications across locations",
      "Conferencing and collaboration features",
      "PBX systems from Mitel and Safe Eye with expandable licenses",
      "Support for 20–12,000 lines with up to 600 concurrent calls",
      "1TB storage, unlimited intercom, and unlimited IVR",
      "IP phones for hotel rooms, offices, and various use cases"
    ],
    image: require('../assets/solutions/voip-phone-system.png'),
    images: [
      require('../assets/solutions/voip-phone-system_1.png'),
      require('../assets/solutions/voip-phone-system_2.png'),
      require('../assets/solutions/voip-phone-system_3.png'),
    
      
    ],
    productsLink: 'https://safeeye.uk/product-category/ip-phone/'
  },
  {
    slug: 'iptv-system', 
    title: 'IPTV System', 
    category: 'Communication Systems', 
    intro: 'We partner with Uniguest to provide IPTV solutions that stream TV and video over IP networks for live and on-demand viewing',
    body: [
      'Unlike cable or satellite, IPTV uses server‑stored content and internet protocols so viewers can watch from anywhere with connectivity.',
      'On‑demand capability lets users choose what to watch and when.'
    ],
    features: [
      'Live and on‑demand video over IP',
      'Access from connected devices anywhere',
      'Personalized content delivery'
    ],
    image: require('../assets/solutions/iptv-system.png')
  },
  {
    slug: 'public-address', 
    title: 'Public Address', 
    category: 'Communication Systems', 
    intro: 'Public Address and Voice Alarm (PAVA) systems from BOSCH provide clear communications for daily use and emergencies.',
    body: [
      'They broadcast precise messages across facilities so occupants receive vital information quickly and clearly.',
      'During emergencies such as fire, PAVA supports safe, efficient evacuation and integrates with life‑safety systems.'
    ],
    features: [
      'High‑intelligibility announcements and paging',
      'Certified voice alarm for evacuation',
      'Integration with fire/safety systems'
    ],
    image: require('../assets/solutions/public-address.png')
  },
  {
    slug: 'professional-music', 
    title: 'Professional Music', 
    category: 'Communication Systems', 
    intro: 'As the distributor for Amate Audio, we offer premium sound systems that deliver crystal‑clear, high‑fidelity audio for malls, cafes, restaurants, and public spaces.',
    body: [
      'Systems provide powerful, consistent coverage and elevate ambiance while integrating easily across environments.',
      'Commercial‑grade designs ensure durability and intuitive operation for daily use.'
    ],
    features: [
      'High‑definition sound with detailed clarity',
      'Powerful output for large spaces',
      'User‑friendly control',
      'Durable, commercial‑grade construction'
    ],
    image: require('../assets/solutions/professional-music.png')
  },
  {
    slug: 'smatv-system', 
    title: 'SMATV System', 
    category: 'Communication Systems', 
    intro: 'With ANKARO (Germany), we provide high‑tech SMATV and distribution platforms for smart homes and buildings with integrated communication and security.',
    body: [
      'Solutions centralize satellite/terrestrial TV and audio/video distribution and integrate with automation platforms.',
      'Engineered for efficiency and reliability in residential and commercial environments.'
    ],
    features: [
      'Centralized satellite/terrestrial TV distribution',
      'Integration with smart building systems',
      'German engineering for reliability'
    ],
    image: require('../assets/solutions/smatv-system.png')
  },
  {
    slug: 'gsm', 
    title: 'GSM', 
    category: 'Communication Systems', 
    intro: 'The GSM system is a widely adopted digital cellular technology that delivers secure, reliable mobile voice and data services and forms the foundation of mobile networks worldwide.',
    body: [
      'GSM supports services such as voice calls, SMS messaging, and mobile data by connecting devices to a network of base stations, ensuring seamless connectivity across wide geographic areas.',
      'Our GSM solutions support large-scale deployments across smart buildings, transportation hubs, industrial sites, and remote areas where consistent mobile coverage is critical.'
    ],
    features: [
      'Secure, reliable mobile voice and data connectivity',
      'Support for voice calls, SMS, and packet data',
      'Suitable for smart buildings, transport hubs, and industrial sites',
      
    ],
    image: require('../assets/solutions/gsm.png')
  },

  {
    slug: 'building-management-system', 
    title: 'Building Management System', 
    category: 'Automation Solutions', 
    intro: "We partner with Honeywell to provide advanced Building Management Systems (BMS) for efficient, safe, and comfortable facilities.",
    body: [
      "BMS centralizes control of HVAC, lighting, power distribution, fire safety, and security, improving operational efficiency and reducing energy consumption.",
      "Operators can automate routine tasks, receive real-time alerts, and make data-driven decisions. Solutions are scalable for offices, hospitals, industrial complexes, and smart buildings."
    ],
    features: [
      "Centralized monitoring and control",
      "Energy optimization and analytics",
      "Alarms, trends, and automation at scale"
    ],
    image: require('../assets/solutions/building-management-system.png'),
    images: [
      require('../assets/solutions/building-management-system_1.png'),
      require('../assets/solutions/building-management-system.png'),
      
    ],
  },
  /* 
  {
    slug: 'guestroom-management-system', 
    title: 'Guestroom Management System', 
    category: 'Automation Solutions', 
    intro: "We partner with KNX to provide automated Guestroom Management Systems for hotels, enhancing comfort and efficiency.",
    
     body: [
      'Guestroom management systems control lighting, HVAC, and entertainment systems in hotel rooms.',
      'These systems enhance guest experience and improve operational efficiency for hotels.'
    ],
    image: require('../assets/solutions/guestroom-management-system.png')
  },
  {
    slug: 'smart-home', 
    title: 'Smart Home', 
    category: 'Automation Solutions', 
    intro: 'Smart homes use network‑connected devices to control and monitor lighting, heating, security, and surveillance locally and remotely.',
    body: [
      'Also called automation, smart homes provide comfort, security, and energy efficiency while enabling control through smartphones, tablets, and other connected devices.',
      'Integrations span lighting, climate, security, and entertainment for a unified experience.'
    ],
    features: [
      'Remote control via mobile devices',
      'Energy‑saving automation',
      'Integrated security and monitoring'
    ],
    image: require('../assets/solutions/smart-home.png')
  },
  {
    slug: 'lighting-control', 
    title: 'Lighting Control', 
    category: 'Automation Solutions', 
    intro: 'KNX lighting control delivers intelligent, efficient lighting with precise intensity per area and full automation.',
    body: [
      'Systems can be centrally automated to ensure optimal lighting when needed and conserve energy when not—ideal for homes, offices, and large commercial buildings, indoors and outdoors.'
    ],
    features: [
      'Per‑zone dimming and scenes',
      'Central automation and scheduling',
      'Significant energy savings'
    ],
    image: require('../assets/solutions/lighting-control.png')
  },
  */
  {
    slug: 'parking-system', 
    title: 'Parking System', 
    category: 'Automation Solutions', 
    intro: "We partner with Honeywell to provide automated parking systems that streamline vehicle flow.",
    body: [
      "Our system automates vehicle entry and exit using sensors and controllers, improving traffic circulation and operational efficiency.",
      "Centralized software provides real-time monitoring, guiding screens direct drivers to available spaces, and an automated ticketing system tracks access and usage."
    ],
    features: [
      "Automated vehicle entry and exit",
      "Centralized real-time monitoring",
      "Guiding screens for efficient navigation",
      "Automated ticketing and access tracking",
      "Integration with payment systems"
    ],
    image: require('../assets/solutions/parking-system.png')
  },

  {
    slug: 'gpon-system', 
    title: 'GPON System', 
    category: 'Networking Solutions', 
    intro: 'The GPON system is a high-performance broadband access network that delivers internet, telephone, and television through a single optical fiber cable, providing a reliable and cost-effective solution for residential and commercial users.',
    body: [
      'With a bandwidth capacity of up to 1 Gbit/s, GPON offers a dedicated fiber-optic channel to each user, ensuring stable connections and consistent high-speed performance. The system supports guaranteed quality of service, making it ideal for applications that require low latency and high reliability, such as video conferencing, IPTV, VoIP, and cloud-based services.',
      'These solutions are designed to be scalable, energy-efficient, and easy to deploy, making them suitable for modern smart buildings, residential compounds, business parks, hotels, and large campus networks.'
    ],
    features: [
      'Triple-play services (internet, voice, TV) over a single fiber',
      'Up to 1 Gbit/s bandwidth per user',
      'Dedicated fiber channel for stable performance',
      'Quality of Service (QoS) for low latency and reliability',
      'Supports IPTV, VoIP, video conferencing, and cloud services',
      'Scalable architecture for campuses and multi-dwelling units',
      'Energy-efficient design and simplified deployment'
    ],
    image: require('../assets/solutions/gpon-system.png')
  },
  {
    slug: 'networking-system-internet', 
    title: 'Networking System & Internet', 
    category: 'Networking Solutions', 
    intro: 'Networking systems provide reliable internet connectivity and network infrastructure.',
    body: [
      'Our networking solutions include routers, switches, and network infrastructure for reliable connectivity.',
      'These systems ensure high-speed internet access and secure network communication.'
    ],
    image: require('../assets/solutions/networking-system-internet.png'),

  },

  {
    slug: 'raised-floor-system', 
    title: 'Raised Floor System', 
    category: 'Data Centers', 
    intro: 'A raised floor is an elevated platform above a solid base that creates a hidden void for routing mechanical, electrical, and data services.',
    body: [
      'It enables efficient cable management and HVAC distribution without cluttering the workspace—ideal for data centers, control rooms, server rooms, offices, and other environments requiring flexibility and accessibility.',
      'Benefits include fast modifications, easy maintenance, and clean, organized spaces.'
    ],
    features: [
      'Under‑floor cable and HVAC distribution',
      'Quick reconfiguration and maintenance',
      'Durable, high load‑bearing performance'
    ],
    image: require('../assets/solutions/raised-floor-system.png')
  },
  {
    slug: 'data-center', 
    title: 'Data Center', 
    category: 'Data Centers', 
    intro: '',
    body: [
      '',
      'Solutions include power, cooling, security, and monitoring to ensure peak efficiency and reliability.'
    ],
    features: [
      'Enterprise‑grade power, cooling, and security',
      'Optimized facilities for compute, storage, and telecom',
      "Blue Storm rack & accessories for seamless Installation and Management."
      
    ],
    image: require('../assets/solutions/data-center.png')
  },
  {
    slug: 'structured-cabling-system', 
    title: 'Structured Cabling System', 
    category: 'Data Centers', 
    intro: '',
    body: [
      'Structured cabling systems organize and manage network cables for optimal performance.',
      'These systems support current and future network requirements with standardized components.'
    ],
    image: require('../assets/solutions/structured-cabling-system.png')
  },

  {
    slug: 'nurse-call-system', 
    title: 'Nurse Call System', 
    category: 'Facility Management', 
    intro: 'Nurse call systems provide essential communication between patients and healthcare staff.',
    body: [
      'We provide Intercall (UK) nurse call systems, which enable patients to quickly request assistance from healthcare staff. These systems enhance patient care and improve staff efficiency in healthcare facilities.',
      
    ],
    features: [
      'Backbone with controllers and isolators distributed throughout the halls',
      'Call points,Over‑door lights, LCD displays, and staff presence',
      'Emergency and code‑blue pull cords',
      'Integration with hospital systems'
    ],
    image: require('../assets/solutions/nurse-call-system.png')
  },
  { 
    slug: 'master-clock', 
    title: 'Master Clock', 
    category: 'Facility Management', 
    intro: 'Synchronized clock systems (e.g., Bodet, France) display and distribute accurate time across facilities.',
    body: [
      'Bodet solutions serve airports, hospitals, broadcast centers, data centers, government institutions, and corporate buildings with high‑precision time distribution.',
      'Deployments range from basic school networks to advanced installations supporting thousands of synchronized slave clocks across campuses.'
    ],
    features: [
      'Facility‑wide synchronized time',
      'High precision and reliability',
      'Scales from small sites to campuses'
    ],
    image: require('../assets/solutions/master-clock.png')
  }
];

export function getSolutionBySlug(slug) {
  return solutions.find((s) => s.slug === slug);
}
